import { Form, NumberBox, Popup, SelectBox, TextArea, TextBox } from 'devextreme-react';
import { EmptyItem, SimpleItem } from 'devextreme-react/form';
import { Component } from 'react';
import TarikhPicker from '../TarikhPicker';
import { apiPostP } from '../../GanjiTools';
import TarikhTimePicker from '../TarikhTimePicker';
import Uploader from '../Uploader';
import PrepareAuxFile, { AuxFile } from './AuxFile';
import { Format } from 'devextreme-react/number-box';
import FileUploadScanner from '../utils/FileUploadScanner';
import VirtualScannerComponent from '../utils/VirtualScannerComponent';
import ScanButton from '../utils/ScanButton';

class Deal extends Component {
    state = {
        row: this.props.row ?? {},
        companies: [],
        drivers: [],
    }

    onDealSavedOrCanceled = saved => {
        AuxFile.manageTemporaries('Deal', saved === false ? 'remove' : 'keep', this.state.focusedDeal?.id);
        this.props.onDealSavedOrCanceled?.(saved);
    }

    componentDidMount() {
        console.log('Deal is mounted: ', this.props.row);
        Promise.all([
            apiPostP('/api/dyna/rowsAsLookup/taraDriver', {}),
            apiPostP('/api/dyna/rowsAsLookup/customer', {}),
            apiPostP('/api/dyna/rowsAsLookup/tanker', {})
        ]).then(res => {
            let _error = '';
            if (res?.length !== 3) {
                res = [[], [], []];
                _error = 'No response';
            }
            let drivers = res[0]?.list ?? [], customers = res[1]?.list ?? [], tankers = res[2]?.list ?? [];
            let error = _error + (res[0]?.error ?? '') + (res[1]?.error ?? '') + (res[2]?.error ?? '');
            if (error?.length > 0) {
                window.notif(error);
                return;
            }
            this.setState({ drivers, customers, tankers });
        }).catch(window.notif)
    }
    static types = [
        { id: 0, summary: 'پرداخت به تانکر' },
        { id: 1, summary: 'پرداخت به راننده' },
        { id: 2, summary: 'خرید کالا' },
        { id: 3, summary: 'فروش کالا' },
    ];

    render() {
        let type = this.props.row?.dealtype;
        console.log('deal type: ', type);

        return (
            <div>
                <Form colCount={60} rtlEnabled labelLocation='left'
                >
                    {type === 0 &&
                        <SimpleItem colSpan={30} label={{ text: 'تانکر' }}
                        >
                            <SelectBox items={this.state.tankers} valueExpr='id' displayExpr='summary' rtlEnabled
                                value={this.state.row.fk_tanker}
                                //onValueChanged={e => this.setState({ row: { ...this.state.row, fK_ShareHolder: e.value } })}
                                onValueChanged={e => { this.state.row.fk_tanker = e.value; this.forceUpdate(); }}
                            />
                        </SimpleItem>
                    }
                    {type === 1 &&
                        <SimpleItem colSpan={30} label={{ text: 'راننده' }}
                        >
                            <SelectBox items={this.state.drivers} valueExpr='id' displayExpr='summary' rtlEnabled
                                value={this.state.row.fk_driver}
                                //onValueChanged={e => this.setState({ row: { ...this.state.row, fK_ShareHolder: e.value } })}
                                onValueChanged={e => { this.state.row.fk_driver = e.value; this.forceUpdate(); }}
                            />
                        </SimpleItem>
                    }
                    {type === 2 &&
                        <SimpleItem colSpan={30} label={{ text: 'کالا' }}
                        >
                            <TextBox rtlEnabled
                                value={this.state.row.ware}
                                //onValueChanged={e => this.setState({ row: { ...this.state.row, fK_ShareHolder: e.value } })}
                                onValueChanged={e => { this.state.row.ware = e.value; this.forceUpdate(); }}
                            />
                        </SimpleItem>
                    }
                    {(type === 2 || type === 3) &&
                        <SimpleItem colSpan={30} label={{ text: type === 3 ? 'خریدار' : 'فروشنده' }}
                        >
                            <SelectBox items={this.state.customers} valueExpr='id' displayExpr='summary' rtlEnabled
                                value={this.state.row.fk_customer}
                                //onValueChanged={e => this.setState({ row: { ...this.state.row, fK_ShareHolder: e.value } })}
                                onValueChanged={e => { this.state.row.fk_customer = e.value; this.forceUpdate(); }}
                            />
                        </SimpleItem>
                    }

                    <SimpleItem colSpan={30} label={{ text: 'مبلغ' }}>
                        <NumberBox min={0} format={{ precision: 0, useCurrencyAccountingStyle: true }}
                            value={this.state.row.val}
                            onValueChanged={e => { this.state.row.val = e.value; this.forceUpdate(); }}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={30} label={{ text: 'تاریخ' }}>
                        <TarikhPicker
                            value={this.state.row.tarikh}
                            onValueChanged={e => { this.state.row.tarikh = e; this.forceUpdate(); }}
                        />
                    </SimpleItem>
                    {
                        type !== 2 && <EmptyItem colSpan={30} />
                    }

                    <SimpleItem colSpan={60} label={{ text: 'شرح' }}>
                        <TextArea
                            value={this.state.row.comment}
                            onValueChanged={e => { this.state.row.comment = e.value; this.forceUpdate(); }}
                        />
                    </SimpleItem>

                    {/* <SimpleItem colSpan={30}>
                        <Uploader selectButtonText={'بارگذاری اسناد...'}
                            subPath={AuxFile.getTempPath('Deal', this.state.row?.id)}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={30}>
                        <ScanButton subPath={AuxFile.getTempPath('Deal', this.state.row?.id)} />
                    </SimpleItem> 
                    */}

                    <SimpleItem colSpan={60}>
                        <PrepareAuxFile table='Deal' rowId={this.state.row?.id} />
                    </SimpleItem>
                </Form>
            </div>
        );
    }
}

export default Deal;
